<template>
  <div class="m-4 border border rounded-xl overflow-hidden">
    <!-- Header -->
    <div class="px-3 py-2 font-semibold text-lg bg-gray-50 border-b">Custom Domains</div>

    <div class="">
      <!-- loader -->
      <div v-if="loading" v-loading="loading" style="height: 100px"></div>

      <template v-else>
        <!-- No Domains Configured yet -->
        <div class="flex flex-col items-center justify-center" v-if="domainList.length === 0">
          <el-empty description="No domains configured yet" />
          <el-button type="primary" @click="showAddDomainDialog" :loading="savingData">Add Custom Domain</el-button>
        </div>

        <div v-else>
          <div class="bg-orange-50 border-b border-orange-200 text-orange-600 p-4 overflow-hidden" v-if="domainList.length != 0">
            <p class="font-bold"><i class="fa-solid fa-triangle-exclamation"></i>&nbsp; Configuration Required</p>
            <div class="text-sm pt-1">
              <p>Each domain will need following additional configuration:</p>
              <p>1. Make sure you have added domain CNAME record pointing to l.gltcs.in.</p>
              <p>
                2. SSL certificate must be issued for the custom domain. Please contact Growlytics support team to configure SSL.
              </p>
            </div>
          </div>

          <!-- Domain List -->
          <div class="px-3 p-3 border-b" v-for="(domain, index) in domainList" :key="index">
            <div class="flex items-center">
              <div class="flex-1 ">
                {{ domain }}
                <br />
                <!-- Verify Configuration -->
                <span
                  class="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer text-xs"
                  @click.stop="verifyDomainConfiguration(domain)"
                >
                  Verify Configuration
                </span>
              </div>

              <!-- Set default domain button -->
              <div class="mr-3">
                <div class="text-xs text-white bg-primary-600 rounded-full px-3 py-1" v-if="domain === defaultDomain">
                  <i class="fa-solid fa-star"></i>&nbsp;Default
                </div>
                <el-button type="primary" size="mini" plain round @click.stop="setDefaultDomain(domain)" v-else
                  >Set as default</el-button
                >
              </div>

              <!-- delete button -->
              <el-button type="danger" icon="el-icon-delete" size="mini" plain circle @click.stop="removeDomain(index)" />
            </div>
          </div>

          <!-- Add domain button -->
          <div class="py-3 mt-2 mx-3" v-if="domainList.length < 5">
            <el-button type="primary" @click="showAddDomainDialog" :loading="savingData">Add Custom Domain</el-button>
          </div>
        </div>
      </template>
    </div>

    <!-- Verification Dialog - Will Verify if ssl is correct of that domain and cname is pointing to i.gltcs.in or not. -->

    <el-dialog
      :title="'Verifying - ' + (domainVerification.domain ? ' ' + domainVerification.domain : '')"
      v-model="domainVerification.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="true"
    >
      <!-- In progress ui. -->
      <div v-if="domainVerification.inProgress" class="flex flex-col items-center justify-center p-6">
        <div class="mt-10 w-40 h-20 w-full" v-loading="true"></div>
        <div class="-mt-2">
          Verifying SSL Certificate & CName Record
        </div>
      </div>

      <!-- Result UI -->
      <div v-else class="m-6">
        <!-- SSL -->
        <div style="font-size: 20px; font-weight: bold;">
          <i class="fa-solid fa-circle-check text-green-600" v-if="domainVerification.ssl && domainVerification.ssl.valid"></i>
          <i class="fa-solid fa-circle-xmark text-red-600" v-else></i>
          <span class="ml-2">SSL Certificate</span>
          <div class="text-sm" style="font-weight: normal;">{{ domainVerification.ssl.message }}</div>
        </div>

        <!-- Cname -->
        <div class="mt-6" style="font-size: 20px; font-weight: bold;">
          <i
            class="fa-solid fa-circle-check text-green-600"
            v-if="domainVerification.cname && domainVerification.cname.valid"
          ></i>
          <i class="fa-solid fa-circle-xmark text-red-600" v-else></i>
          <span class="ml-2">CNAME Record</span>
          <div class="text-sm" style="font-weight: normal;">{{ domainVerification.cname.message }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CustomDomainComponent from './CustomDomainComponent'
export default CustomDomainComponent
</script>
